export function compose(middleware) {
    if (!Array.isArray(middleware)) {
        throw new TypeError("Middleware stack must be an array!");
    }
    for (const fn of middleware) {
        if (typeof fn !== "function") {
            throw new TypeError("Middleware must be composed of functions!");
        }
    }
    return function* composeFn(context, mdw) {
        // last called middleware #
        let index = -1;
        function* dispatch(i) {
            if (i <= index) {
                throw new Error("next() called multiple times");
            }
            index = i;
            let fn = middleware[i];
            if (i === middleware.length) {
                fn = mdw;
            }
            if (!fn) {
                return;
            }
            const nxt = dispatch.bind(null, i + 1);
            yield* fn(context, nxt);
        }
        yield* dispatch(0);
    };
}
